import React, { useState, useEffect } from 'react';

const BANNER_KEY = 'app_banner_dismissed';

export default function AppDownloadBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Only show on mobile/tablet, and only if not dismissed
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const dismissed = localStorage.getItem(BANNER_KEY);
    if (isMobile && !dismissed) setVisible(true);
  }, []);

  const dismiss = () => {
    localStorage.setItem(BANNER_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12,
      background: '#0e1b2c', color: '#fff',
      padding: '10px 16px',
      borderBottom: '1px solid rgba(255,255,255,0.08)',
      position: 'sticky', top: 0, zIndex: 999,
    }}>
      {/* App icon */}
      <div style={{
        width: 44, height: 44, borderRadius: 10, flexShrink: 0,
        background: '#10b981', display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 22,
      }}>
        📱
      </div>

      {/* Text */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 700, lineHeight: 1.3 }}>BrokerConnect App</div>
        <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.55)', marginTop: 2 }}>
          Track referrals & commissions on the go
        </div>
      </div>

      {/* CTA */}
      {isIOS && (
        <a
          href="https://apps.apple.com/app/brokerconnect/id6748849677"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            background: '#10b981', color: '#0e1b2c',
            padding: '7px 14px', borderRadius: 20,
            fontSize: 12, fontWeight: 700, textDecoration: 'none', flexShrink: 0,
          }}
        >
          Get App
        </a>
      )}

      {/* Dismiss */}
      <button
        onClick={dismiss}
        style={{
          background: 'none', border: 'none', color: 'rgba(255,255,255,0.4)',
          fontSize: 20, lineHeight: 1, cursor: 'pointer', padding: '0 4px', flexShrink: 0,
        }}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
